import fetch from 'isomorphic-fetch'
import { path } from 'ramda'
import { push } from 'react-router-redux'
import * as ActionTypes from '../actions/actionTypes'
import * as actions from '../actions/authActions'
import { loginOptions, loginPayload, refreshPayload, mfaPayload } from '../config/authConfig'
import history from '../history'
import { getPermissions, urlEncode } from '../utils/mainUtils'
import { handleAuthError, handleResponse, handleTokenError, handleTokenResponse } from './apiUtils'
import * as urls from './urls'

export const loginUser = (username, password) => dispatch => {
    const opts = {
        body: urlEncode({ username, password, ...loginPayload }),
        ...loginOptions
    }

    return fetch(urls.oauthToken, opts)
        .then(response => {
            // Check if response is 401 (MFA required)
            if (response.status === 401) {
                return response.json().then(json => {
                    if (json.error === 'mfa_required' && json.mfa_token) {
                        // Reject with MFA info so component can handle it
                        return Promise.reject({
                            mfaRequired: true,
                            mfaToken: json.mfa_token,
                            email: json.error_description
                        })
                    }
                    // Other 401 errors
                    return Promise.reject(response)
                })
            }
            return handleResponse(response)
        })
        .then(json => dispatch(actions.loginSuccess(json)))
        .then(() => history.push('/'))
        .catch(error => {
            // If it's an MFA error, propagate it
            if (error.mfaRequired) {
                throw error
            }
            // Otherwise handle as normal auth error
            return handleAuthError(dispatch, actions.loginFailure, 'Ошибка авторизации!')(error)
        })
}

export const verifyMfaCode = (mfaCode, mfaToken) => dispatch => {
    const opts = {
        body: urlEncode({
            mfa_code: mfaCode,
            mfa_token: mfaToken,
            ...mfaPayload
        }),
        ...loginOptions
    }

    return fetch(urls.oauthToken, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.loginSuccess(json)))
        .then(() => history.push('/'))
        .catch(handleAuthError(dispatch, actions.loginFailure, 'Неверный код MFA!'))
}

/** @thunk **/
export const logoutUser = () => dispatch => {
    dispatch(actions.logout())
    dispatch(push(urls.login))
}

export const fetchRefreshToken = refreshTokenValue => {
    const options = {
        body: urlEncode({ refresh_token: refreshTokenValue, ...refreshPayload }),
        ...loginOptions
    }

    return fetch(urls.oauthToken, options).then(handleTokenResponse)
}

export const refreshToken = dispatch => {
    /** @action **/
    const tokenRefreshRequest = freshTokenPromise => ({
        type: ActionTypes.TOKEN_REFRESH_REQUEST,
        freshTokenPromise
    })

    /** @action **/
    const tokenRefreshSuccess = token => ({
        type: ActionTypes.TOKEN_REFRESH_SUCCESS,
        payload: {
            token: {
                ...token,
                permissions: getPermissions(token),
                time: +new Date()
            }
        }
    })

    /** @action **/
    const tokenRefreshFailure = error => ({
        type: ActionTypes.TOKEN_REFRESH_FAILURE,
        payload: { error }
    })

    const refreshTokenValue = path(['auth', 'token', 'refresh_token'], JSON.parse(localStorage.getItem('redux')))

    const freshTokenPromise = fetchRefreshToken(refreshTokenValue)
        .then(payload => {
            dispatch(tokenRefreshSuccess(payload))
            return payload
        })
        .catch(handleTokenError(dispatch, tokenRefreshFailure, 'Время сессии истекло!'))

    dispatch(tokenRefreshRequest(freshTokenPromise))

    return freshTokenPromise
}


// WEBPACK FOOTER //
// ./src/api/authApi.js